import React, { Component } from "react" ;

class Header extends Component{
	constructor(props){
		super(props);
		this.state={direction:undefined,accessor:undefined};
		this.orderBy = this.orderBy.bind(this);
	}

	orderBy(direction,accessor){
		this.setState({direction:direction, accessor:accessor});
		this.props.orderBy(accessor,direction);
	}

	render(){
		return (
			<thead>
				<tr>
					{
						this.props.columns.map((column, j) =>
							<th scope="col" key={j} width={column.width}>
								{typeof column.accessor === "string" &&
									<div className="durumaGore">
										<button className="tableBtn">
											{column.Header}
											{(column.sortable || column.sortable === undefined) &&(
												<div className="konum">
													{this.state.accessor !== column.accessor &&
														<i style={{padding: '3px'}}
														   onClick={(e)=>this.orderBy("asc",column.accessor)}
														   className="konum fas fa-caret-up arrows-1_minimal-right"/>
													}
													{this.state.accessor !== column.accessor &&
														<i style={{padding: '3px'}}
														   onClick={(e) => this.orderBy("desc", column.accessor)}
														   className="konum fas fa-caret-down arrows-1_minimal-right"/>
													}
													{this.state.accessor === column.accessor && this.state.direction === "asc" &&
															<i style={{padding: '3px'}}
															   onClick={(e) => this.orderBy("desc", column.accessor)}
															   className="konum fas fa-caret-up arrows-1_minimal-right"/>
													}
													{this.state.accessor === column.accessor && this.state.direction === "desc" &&
															<i style={{padding: '3px'}}
															   onClick={(e) => this.orderBy("asc", column.accessor)}
															   className="konum fas fa-caret-down arrows-1_minimal-right"/>

													}
												</div>)
											}
										</button>
									</div>
								}
								{column.accessor instanceof Array &&
									column.accessor.map((data,k) =>
										<span style={{padding: '0px'}} key={k}>
											<div className="durumaGore" style={{padding: '0px'}}>
												<button className="tableBtn">
													{data.Header}
													{(data.sortable || data.sortable === undefined) &&
													(<div className="konum">
															{this.state.accessor !== data.accessor &&
																<i style={{padding: '3px'}}
																   onClick={(e)=>this.orderBy("asc",data.accessor)}
																   className="konum fas fa-caret-up arrows-1_minimal-right"/>
															}
															{this.state.accessor !== data.accessor &&
																<i style={{padding: '3px'}}
																   onClick={(e) => this.orderBy("desc", data.accessor)}
																   className="konum fas fa-caret-down arrows-1_minimal-right"/>
															}
															{this.state.accessor === data.accessor && this.state.direction === "asc" &&
																<i style={{padding: '3px'}}
																   onClick={(e) => this.orderBy("desc", data.accessor)}
																   className="konum fas fa-caret-up arrows-1_minimal-right"/>
															}
															{this.state.accessor === data.accessor && this.state.direction === "desc" &&
																<i style={{padding: '3px'}}
																   onClick={(e) => this.orderBy("asc", data.accessor)}
																   className="konum fas fa-caret-down arrows-1_minimal-right"/>
															}
														</div>)
													}
												</button>
											</div>
											{k+1 <column.accessor.length &&
												<hr/>
											}
										</span>
									)
								}
							</th>
						)
					}
				</tr>
			</thead>
		);
	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Table/Header.js